import { request } from 'dygc'
export function findOneUsingGET(params) {
  return request({
    url: '/wjluck/global_config/find_one',
    method: 'get',
    params: params
  })
}

export function postPrizePage(params) {
  return request({
    url: '/wjluck/prize/page',
    method: 'post',
    // method: "get",
    data: params
  })
}

export function addUsingPOST_1(params) {
  return request({
    url: '/wjluck/lottery_log/add',
    method: 'post',
    data: params
  })
}

export function drawUsingPOST(params) {
  return request({
    url: '/wjluck/lottery_log/draw',
    method: 'post',
    data: params
  })
}

export function receiveUsingPUT(params) {
  return request({
    url: '/wjluck/lottery_log/receive',
    method: 'put',
    data: params
  })
}

export function queryUsingPOST(params) {
  return request({
    url: '/wjluck/lottery_log/current_user/query',
    method: 'post',
    data: params
  })
}
